// extracted by mini-css-extract-plugin
export var container = "Grid-module--container--1fvRG";
export var containerBlock = "Grid-module--containerBlock--1-yoG";
export var containerBackground = "Grid-module--containerBackground--3R4uD";
export var background = "Grid-module--background--10RhZ";
export var containerHighlight = "Grid-module--containerHighlight--19Wde";
export var show = "Grid-module--show--w8X-2";
export var showFadeInDown = "Grid-module--show-fade-in-down--3MFFg";
export var showFadeInUp = "Grid-module--show-fade-in-up--1jovT";
export var hideFadeOut = "Grid-module--hide-fade-out--3R1-U";